import { SelectedVisitState } from './selectedVisitInterface';
import { REMINDER_AVAILABILITY } from '@ax/constants';
import { NOTE_STATUS } from '@ax/constants';

export const selectedVisitSliceName = 'selectedVisit';

export const selectedVisitInitialStateValue: SelectedVisitState = {
  uuid: '',
  patientFirstName: '',
  patientLastName: '',
  appointmentStartTime: '',
  patientAge: 0,
  patientGender: '',
  chiefComplaint: '',
  roomNumber: '',
  source: '',
  reminderAvailability: REMINDER_AVAILABILITY.NO_DATA,
  latestNoteStatus: { status: NOTE_STATUS.NEW_APPOINTMENT, createdAt: '' },
};
